<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="服务名称">
          <el-input placeholder="请输入服务名称" v-model="formInline.serve_name"></el-input>
        </el-form-item>
        <el-form-item label="用户名称">
          <el-input placeholder="请输入用户名称" v-model="formInline.user_name"></el-input>
        </el-form-item>
        <el-form-item label="商家名称">
          <el-input placeholder="请输入商家名称" v-model="formInline.supply_name"></el-input>
        </el-form-item>
        <el-form-item label="审核状态">
          <el-select v-model="formInline.audit_status" placeholder="请选择" clearable>
            <el-option label="待审核" :value="0"></el-option>
            <el-option label="审核通过" :value="1"></el-option>
            <el-option label="审核拒绝" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <!-- <el-button size="small" icon="el-icon-download" @click="exportData">导出Excel{{ selectedRows.length > 0 ? '(' + selectedRows.length + ')' : '' }}</el-button>
          <el-button size="small" icon="el-icon-upload2" @click="importClick">导入</el-button> -->
        </el-form-item>
      </el-form>
    </div>

    <!-- <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加服务记录</el-button>
    </div> -->

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange" ref="multipleTable">
            <el-table-column type="selection" width="45"></el-table-column>
            <!-- <el-table-column prop="serve_record_id" label="记录ID" width="80"></el-table-column> -->
            <!-- <el-table-column prop="serve_id" label="服务ID" width="80"></el-table-column> -->
            <el-table-column prop="serve_name" label="服务名称" min-width="150"></el-table-column>
            <el-table-column prop="user_name" label="用户名称" width="120"></el-table-column>
            <!-- <el-table-column prop="user_id" label="用户ID" width="80"></el-table-column> -->
            <!-- <el-table-column prop="supply_id" label="商家ID" width="80"></el-table-column> -->
            <el-table-column prop="supply_name" label="商家名称" width="120"></el-table-column>

            <el-table-column prop="sort" label="排序" width="70"></el-table-column>
            <el-table-column prop="audit_status" label="审核状态" width="100">
              <template slot-scope="scope">
                <el-tag :type="getAuditStatusType(scope.row.audit_status)" size="small">
                  {{ getAuditStatusText(scope.row.audit_status) }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="reason" label="拒绝原因" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="160"></el-table-column>
            <el-table-column prop="update_time" label="更新时间" width="160"></el-table-column>
            <el-table-column fixed="right" label="操作" width="140">
              <template slot-scope="scope">
                <el-button @click="reviewClick(scope.row)" type="text" size="small" :disabled="scope.row.audit_status !== 0">审核</el-button>
                <!-- <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button> -->
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
<!--     
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit :open_edit="open_edit" :serve_record_id="serve_record_id" v-if="open_edit" @close="closeEdit"></Edit>
    <Import :open_import="open_import" v-if="open_import" @close="closeImport"></Import> -->
    
    <!-- 审核弹窗 -->
    <el-dialog title="审核服务记录" :visible.sync="dialogVisible" width="500px" @close="dialogFormVisible" :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true">
      <el-form :model="auditForm" label-width="100px" ref="auditForm">
        <el-form-item label="服务名称">
          <span>{{ auditForm.serve_name }}</span>
        </el-form-item>
        <el-form-item label="用户名称">
          <span>{{ auditForm.user_name }}</span>
        </el-form-item>
        <el-form-item label="商家名称">
          <span>{{ auditForm.supply_name }}</span>
        </el-form-item>
        <el-form-item label="审核状态" prop="audit_status" required>
          <el-radio-group v-model="auditForm.audit_status">
            <el-radio :label="1">审核通过</el-radio>
            <el-radio :label="2">审核拒绝</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="拒绝原因" prop="reason" v-if="auditForm.audit_status === 2">
          <el-input type="textarea" v-model="auditForm.reason" placeholder="请填写拒绝原因" :rows="4" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitAudit" :loading="auditLoading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import ServeApi from '@/api/serve.js';
  // import Add from './part/add.vue';
  // import Edit from './part/edit.vue';


  export default {
    // components: {
    //   Add,
    //   Edit,

    // },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          serve_name: "",
          user_name: "",
          supply_name: "",
          audit_status: ""
        },
        open_add: false,
        open_edit: false,
        open_import: false,
        serve_record_id: "",
        /*选中的*/
        selection: [],
        selectedRows: [],
        /*审核弹窗*/
        dialogVisible: false,
        auditForm: {
          serve_record_id: "",
          serve_name: "",
          user_name: "",
          supply_name: "",
          audit_status: 1,
          reason: ""
        },
        auditLoading: false
      };
    },
    created() {
      /*获取列表*/
      this.getTableList();
    },
    methods: {
      dialogFormVisible() {
        this.dialogVisible = false;
        this.auditForm = {
          serve_record_id: "",
          serve_name: "",
          user_name: "",
          supply_name: "",
          audit_status: 1,
          reason: ""
        };
      },
      
      /* 获取类型文本 */
      getTypeText(type) {
        const typeMap = {
          1: '类型1',
          2: '类型2'
        };
        return typeMap[type] || '-';
      },
      
      /* 获取审核状态文本 */
      getAuditStatusText(status) {
        const statusMap = {
          0: '待审核',
          1: '审核通过',
          2: '审核拒绝'
        };
        return statusMap[status] || '-';
      },
      
      /* 获取审核状态标签类型 */
      getAuditStatusType(status) {
        const typeMap = {
          0: 'warning',
          1: 'success',
          2: 'danger'
        };
        return typeMap[status] || 'info';
      },
      
      /* 多选框选择变化 */
      handleSelectionChange(selection) {
        this.selectedRows = selection;
      },
      
      /* 清空选择 */
      clearSelection() {
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.clearSelection();
        }
        this.selectedRows = [];
      },
      
      closeImport(e) {
        this.open_import = false;
        if (e.type === "success") {
          this.getTableList();
        }
      },
      
      importClick() {
        this.open_import = true;
      },
      
      exportData() {
        let exportParams = {
          serve_name: this.formInline.serve_name,
          user_name: this.formInline.user_name,
          supply_name: this.formInline.supply_name,
          audit_status: this.formInline.audit_status
        };
        
        if (this.selectedRows.length > 0) {
          const selectedIds = this.selectedRows.map(row => row.serve_record_id);
          exportParams.selected_ids = selectedIds.join(',');
        }
        
        let baseUrl = window.location.protocol + '//' + window.location.host;
        let queryString = Object.keys(exportParams)
            .filter(key => exportParams[key] !== '' && exportParams[key] !== undefined)
            .map(key => `${key}=${encodeURIComponent(exportParams[key])}`)
            .join('&');
        
        window.location.href = baseUrl + '/index.php/shop/plus.serve.Index/export?' + queryString;
      },
      
      /*关闭添加*/
      closeAdd(e) {
        this.open_add = false;
        this.getTableList();
      },
      
      closeEdit(e) {
        this.open_edit = false;
        this.getTableList();
      },
      
      getData() {
        this.curPage = 1;
        this.getTableList();
      },
      
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },
      
      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },
      
      /*获取列表*/
      getTableList() {
        let self = this;
        let Params = {
          serve_name: this.formInline.serve_name,
          user_name: this.formInline.user_name,
          supply_name: this.formInline.supply_name,
          audit_status: this.formInline.audit_status,
          page: self.curPage,
          list_rows: self.pageSize
        };
        self.loading = true;
        ServeApi.lists(Params, true)
          .then(data => {
            self.loading = false;
            self.tableData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
          })
          .catch(error => {
            self.loading = false;
          });
      },
      
      /*添加任务*/
      // addClick() {
      //   this.open_add = true;
      // },
      
      /*编辑活动*/
      // editClick(row) {
      //   this.serve_record_id = row.serve_record_id;
      //   this.open_edit = true;
      // },
      
      /*审核按钮点击*/
      reviewClick(row) {
        this.auditForm = {
          serve_record_id: row.serve_record_id,
          serve_name: row.serve_name,
          user_name: row.user_name,
          supply_name: row.supply_name,
          audit_status: 1,
          reason: ""
        };
        this.dialogVisible = true;
      },
      
      /*提交审核*/
      submitAudit() {
        // 验证拒绝原因
        if (this.auditForm.audit_status === 2 && !this.auditForm.reason) {
          this.$message.error('请填写拒绝原因');
          return;
        }
        
        this.auditLoading = true;
        ServeApi.audit({
          serve_record_id: this.auditForm.serve_record_id,
          audit_status: this.auditForm.audit_status,
          reason: this.auditForm.reason
        }, true)
          .then(data => {
            this.auditLoading = false;
            if (data.code === 1) {
              this.$message.success(data.msg || '审核成功');
              this.dialogVisible = false;
              this.getTableList();
            } else {
              this.$message.error(data.msg || '审核失败');
            }
          })
          .catch(error => {
            this.auditLoading = false;
            this.$message.error('审核请求失败');
          });
      },
      
      /*删除*/
      deleteClick(row) {
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            ServeApi.delete({
                serve_record_id: row.serve_record_id
              }, true)
              .then(data => {
                if (data.code === 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getTableList();
                } else {
                  self.$message.error(data.msg || '删除失败');
                }
              })
              .catch(error => {
                self.$message.error('删除请求失败');
              });
          })
          .catch(() => {});
      }
    }
  };
</script>

<style scoped>
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/serve/record/record.vue